import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-page-layout',
  imports: [],
  templateUrl: './page-layout.html',
  host: {
    class: 'block w-full h-full',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageLayout {
  readonly hasSidebar = input(true);
}
